module.exports = __webpack_public_path__ + "static/media/schlegel_train_02.abac4455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/schlegel_train_02.jpg
// module id = 390
// module chunks = 0